module.exports = __webpack_public_path__ + "static/media/active-lease-icon.769baeb0.svg";